// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "about" + "." + "9352d9e4cfe8f3a4" + ".css"
}